import { getWebGlContext, isCanvasSizeNotZero, setupWebGl } from '@library/utils'
import type { MutableRefObject } from 'react'
import { useEffect } from 'react'

import type { IWebGlRender, Nullable } from '../../../types'

export const useLazyRender = (
  canvasRef: MutableRefObject<Nullable<HTMLCanvasElement>>,
  renders: IWebGlRender[],
  update: number,
) => {
  useEffect(() => {
    if (!canvasRef.current || !isCanvasSizeNotZero(canvasRef.current)) return

    const renderingContext = getWebGlContext(canvasRef.current)
    setupWebGl(renderingContext)

    renders.forEach(component => {
      component.render()
    })
  }, [renders, update, canvasRef])
}
